import {cs} from "../../react/chain-services";
import {UseState} from "../../react/use-state";
import {fragments} from "../../react/fragments";
import {GlobalEvent} from "../../react/global-event";
import {Invoke} from "../../react/invoke";

export const GlobalState = ({translate=v=>v, eventName, getValue, defaultValue = undefined, next}) => cs(
    ["state", (_, next) => UseState({
        getInitValue: () => translate(defaultValue),
        next,
    })],
    ({state}) => {
        const check = () => {
            const newState = translate(getValue());
            if (state.value !== newState) {
                state.onChange(newState);
            }
        };
        return fragments(
            next(state.value),

            GlobalEvent({
                eventName: eventName,
                action: check,
                passive: true,
            }),
            typeof window !== "undefined" && Invoke({
                action: check,
            }),
        );
    },
);
